import React, {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {UPDATE_CHAT_CLIENT_DATA} from "../../../constants";
import {ClientAge} from "./ClientAge";
import {ClientWeight} from "./ClientWeight";
import {ClientDiseases} from "./ClientDiseases";
import {ClientRecentDiseases} from "./ClientRecentDiseases";
import {ClientRecentDiets} from "./ClientRecentDiets";
import {ClientLink} from "./ClientLink";

const ChatClientHealth = (props) => {

  const dispatch = useDispatch();
  const client = useSelector(state => state.chat.client);
  const responseillness = useSelector(state => state.chat.responseillness);

  const onClientChanged = useCallback((data) => {
    dispatch({type: UPDATE_CHAT_CLIENT_DATA, client: data});
  }, [dispatch]);

  if (!client) {
    return null;
  }

  return <div className="tabs__wrap">
    <ClientLink code={client.code}  typeCode={2} clientid={client.id} isHealth={true} responseIllness={responseillness} isMsgSend={client.response_illness_send}/>
    <ClientAge client={client} handleChange={onClientChanged}/>
    <ClientWeight client={client} handleChange={onClientChanged}/>
    <ClientDiseases client={client} handleChange={onClientChanged} healthTab={true}/>
    <ClientRecentDiseases client={client} handleChange={onClientChanged}/>
    <ClientRecentDiets client={client} handleChange={onClientChanged}/>
  </div>;
};

export default ChatClientHealth
